const normalizeApiBaseUrl = (value) => value.replace(/\/+$/, '');

// Default to localhost for local dev and the HF backend when deployed.
const getDefaultApiBaseUrl = () => {
  if (typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    return 'http://localhost:8000';
  }

  return 'https://himanshu07coder-deepfake-backend-api.hf.space';
};

const defaultApiBaseUrl = getDefaultApiBaseUrl();
const rawApiBaseUrl = process.env.REACT_APP_API_BASE_URL || defaultApiBaseUrl;
const rawMaxUploadMb = Number(process.env.REACT_APP_MAX_UPLOAD_MB || '100');

export const API_BASE_URL = normalizeApiBaseUrl(rawApiBaseUrl);
export const HEALTH_ENDPOINT = `${API_BASE_URL}/health`;
export const ANALYZE_ENDPOINT = `${API_BASE_URL}/api/analyze`;
export const MAX_UPLOAD_MB = Number.isFinite(rawMaxUploadMb) && rawMaxUploadMb > 0
  ? rawMaxUploadMb
  : 100;
